export const CARD_NAME_PATTERNS = ['karta', 'card', 'kartou']
export const CASH_NAME_PATTERNS = ['hotov', 'cash']

export function isCardPaymentName(name: string): boolean {
  const lower = name.toLowerCase()
  return CARD_NAME_PATTERNS.some((pattern) => lower.includes(pattern))
}

export function isCashPaymentName(name: string): boolean {
  const lower = name.toLowerCase()
  return CASH_NAME_PATTERNS.some((pattern) => lower.includes(pattern))
}

